import { transition } from '@helpers/animate';
import { imageCoverContainer } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { h2, paragraphLarge } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.nav `
  --activeTextColor: ${brand.white};
  --activeBgColor: ${brand.black};

  display: none;

  @media ${from(Device.DesktopSmall)} {
    display: flex;
    height: 100%;
  }

  &::before {
    ${transition('opacity')};

    content: '';
    display: block;
    position: fixed;
    opacity: 0;
    background-color: ${brand.black};
    top: var(--headerNavHeight);
    left: 0;
    height: 0;
    width: 100%;
    z-index: -1;
  }

  &[data-overlay='true']::before {
    opacity: 0.9;
    height: calc(100vh - var(--headerNavHeight));
  }
`;
const List = styled.ul `
  display: flex;
  padding-left: 6px;
`;
const Item = styled.li `
  display: flex;
  overflow: hidden;

  &[data-active='true'] {
    overflow: visible;
  }
`;
const Link = styled.a `
  ${transition('text-decoration-color, color, background-color')}

  display: flex;
  align-items: center;
  color: var(--textColor);
  ${fonts.altGothicNo2.regular};
  font-size: ${fluid(20, 22, Device.TabletLarge)};
  height: 100%;
  padding: 0 ${fluid(12, 24, Device.TabletLarge)};
  text-decoration: underline;
  text-decoration-color: var(--mainBgColor);
  text-decoration-thickness: 3px;
  text-transform: uppercase;
  text-underline-position: under;

  [data-active='true'][data-has-submenu='false'] & {
    text-decoration-color: var(--textColor);
  }

  [data-active='true'][data-has-submenu='true'] & {
    background-color: var(--activeBgColor);
    color: var(--activeTextColor);
    text-decoration-color: var(--activeTextColor);
  }

  [data-current='true'] & {
    text-decoration-color: ${brand.yellow};
  }
`;
const SubWrapper = styled.div `
  ${transition('opacity')};

  opacity: 0;
  display: block;
  position: absolute;
  top: 100%;
  left: 0;
  max-width: 1190px;

  [data-active='true'] & {
    opacity: 1;
  }
`;
const SubInner = styled.div `
  display: grid;
  grid-template-columns: 1fr 1.8fr;
`;
const SubList = styled.ul `
  display: none;
  position: relative;
  background-color: var(--activeBgColor);

  [data-active='true'] & {
    display: block;
  }
`;
const SubItem = styled.li ``;
const SubLink = styled.a `
  ${transition('background-size, color')}
  ${h2};

  line-height: 1;
  color: var(--activeTextColor);
  text-transform: uppercase;
  text-decoration: none;
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 92px;
  padding: 0 12px 0 37px;
  margin: 25px 0;
  background: linear-gradient(
    to right,
    var(--accentColor, ${brand.greyMid}),
    var(--accentColor, ${brand.greyMid})
  );
  background-repeat: no-repeat;
  background-size: 0% 100%;

  [data-active-sub='true'] & {
    background-size: 100% 100%;
    color: ${brand.white};
  }
`;
const PreText = styled.span `
  color: ${brand.yellow};
  font-size: 20px;
`;
const SubContent = styled.div `
  ${transition('opacity')};

  opacity: 0;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 100%;
  width: 180%;
  height: 100%;
  display: flex;
  background-color: var(--activeBgColor);

  [data-active-sub='true'] & {
    opacity: 1;
    z-index: 0;
  }
  [data-active-sub-image='false'] & {
    width: 100%;
  }

  &[data-has-content='true'] {
    border-left: 1px solid ${brand.greyMid};
  }
`;
const SubContentList = styled.ul `
  flex: 1 0 56%;
  padding: 75px 32px 32px;

  li {
    margin-bottom: 30px;
  }
`;
const SubContentLink = styled.a `
  ${transition('text-decoration-color')};
  ${paragraphLarge};

  display: flex;
  align-items: center;
  flex-wrap: wrap;
  color: var(--activeTextColor);
  text-decoration: underline;
  text-decoration-color: var(--activeBgColor);
  text-underline-position: under;

  svg {
    ${transition('margin-left, opacity')};

    width: 14px;
    height: 14px;
    margin: 0;
    opacity: 0;
    color: ${brand.yellow};
  }

  &:hover,
  &:focus {
    text-decoration-color: ${brand.yellow};

    svg {
      margin-left: 12px;
      opacity: 1;
    }
  }
`;
const SubContentChildList = styled.ul `
  width: 100%;
  padding: 0 0 0 32px;
`;
const SubContentImage = styled.img `
  ${imageCoverContainer(true)};

  flex: 1 1 100%;
`;
const NavigationDesktopStyles = {
    Container,
    List,
    Item,
    Link,
    SubWrapper,
    SubInner,
    SubList,
    SubItem,
    SubLink,
    PreText,
    SubContent,
    SubContentList,
    SubContentLink,
    SubContentImage,
    SubContentChildList,
};
export default NavigationDesktopStyles;
